import {
  BusinessesCreateRoute,
  BusinessesEditRoute,
  BusinessesListRoute,
  BusinessesRoute,
  CollectAuditsListRoute,
  CollectAuditsViewRoute,
  CollectsCreateRoute,
  CollectsEditRoute,
  CollectsListRoute,
  CollectsRoute,
  CollectsViewRoute,
  EmailTemplatesCreateRoute,
  EmailTemplatesEditRoute,
  EmailTemplatesRoute,
  ExportDataRoute,
  FeatureConstructorForm,
  FeaturesAnalyticsRoute,
  FeaturesCreateRoute,
  FeaturesDuplicateRoute,
  FeaturesEditRoute,
  FeaturesRoute,
  GroupsCreateRoute,
  GroupsEditRoute,
  GroupsListRoute,
  GroupsRoute,
  HomeRoute,
  ImportedDataRoute,
  InitiativeExportRoute,
  InitiativeImportRoute,
  InitiativesCreateRoute,
  InitiativesDuplicateRoute,
  InitiativesEditRoute,
  InitiativesListRoute,
  InitiativesRoute,
  InitiativesViewRoute,
  LocaleRoute,
  LoginRoute,
  NotAuthorizedRoute,
  PrivateRoute,
  Route,
  SelfAppliedCollectFinishedRedirectRoute,
  SelfAppliedCollectFinishedRoute,
  SelfAppliedCollectRedirectRoute,
  SelfAppliedCollectRoute,
  SelfAppliedCollectTotpRedirectRoute,
  SelfAppliedCollectTotpRoute,
  TermsOfUseRedirectRoute,
  TermsOfUseRoute,
  UsersCreateRoute,
  UsersEditPermissionsRoute,
  UsersEditRoute,
  UsersListRoute,
  UsersRoute,
} from '@/routes/__root.tsx'

export const routeTree = Route.addChildren([
  LoginRoute,
  HomeRoute,
  SelfAppliedCollectRedirectRoute,
  SelfAppliedCollectFinishedRedirectRoute,
  SelfAppliedCollectTotpRedirectRoute,
  TermsOfUseRedirectRoute,
  LocaleRoute.addChildren([
    SelfAppliedCollectRoute,
    SelfAppliedCollectFinishedRoute,
    SelfAppliedCollectTotpRoute,
    NotAuthorizedRoute,
    TermsOfUseRoute,
    PrivateRoute.addChildren([
      UsersRoute.addChildren([
        UsersListRoute,
        UsersEditRoute,
        UsersEditPermissionsRoute,
        UsersCreateRoute,
      ]),
      GroupsRoute.addChildren([
        GroupsListRoute,
        GroupsEditRoute,
        GroupsCreateRoute,
      ]),
      BusinessesRoute.addChildren([
        BusinessesCreateRoute,
        BusinessesListRoute,
        BusinessesEditRoute,
      ]),
      InitiativesRoute.addChildren([
        InitiativesListRoute,
        InitiativesEditRoute,
        InitiativesDuplicateRoute,
        InitiativesCreateRoute,
        InitiativesViewRoute,
        ImportedDataRoute,
        ExportDataRoute,
        InitiativeImportRoute,
        InitiativeExportRoute,
        EmailTemplatesRoute.addChildren([
          EmailTemplatesCreateRoute,
          EmailTemplatesEditRoute,
        ]),
        FeaturesRoute.addChildren([
          FeaturesCreateRoute,
          FeaturesEditRoute,
          FeaturesDuplicateRoute,
          FeatureConstructorForm,
          FeaturesAnalyticsRoute,
          CollectsRoute.addChildren([
            CollectsListRoute,
            CollectsCreateRoute,
            CollectsEditRoute,
            CollectsViewRoute,
            CollectAuditsListRoute,
            CollectAuditsViewRoute,
          ]),
        ]),
      ]),
    ]),
  ]),
])
